import { AsyncPipe, NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
} from '@angular/core';
import {
  FormsModule, ReactiveFormsModule,
} from '@angular/forms';
import { TravelProtectionForm } from '@pages/home/enums/travel-protection-form.enum';
import { FormTrigger } from '@pages/home/interfaces/input-trigger.interface';

import { FormDataService } from '@shared/core/services/form-data.service';
import { FormStep } from '@pages/home/enums/form-step.enum';

import { TooltipComponent } from '@shared/core/modules/tooltip/tooltip.component';
import { FormBuilderComponent } from '../form-builder/form-builder.component';

@Component({
  selector: 'app-form-trigger',
  standalone: true,
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    FormBuilderComponent,
    AsyncPipe,
    TooltipComponent,
  ],
  templateUrl: './form-trigger.component.html',
  styleUrl: './form-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class FormTriggerComponent implements AfterViewInit {
  public data = input.required<FormTrigger>();

  private formS = inject(FormDataService);

  private elementRef = inject(ElementRef);

  private inputRef:HTMLInputElement | null = null;

  public readonly FORM_STEP = FormStep;

  ngAfterViewInit(): void {
    this.inputRef = this.elementRef.nativeElement.querySelector('.form-trigger__input');
  }

  get showInputElem() {
    return (
      this.data().type === TravelProtectionForm.RESIDENCE_STATE

    );
  }

  get isActiveStep() {
    return this.data().step === this.formS.currentStep();
  }

  get buttonClasses(): string {
    let baseClass = 'form-trigger';

    switch (this.data().step) {
      case FormStep.One:
        baseClass += ' first';
        break;
      case FormStep.Four:
        baseClass += ' last';
        break;
      default:
        break;
    }
    if (!this.formS.currentStep()) {
      return `${baseClass} neutral`;
    }
    if (this.isActiveStep) {
      return `${baseClass} active`;
    }
    return baseClass;
  }

  public updateCurrentTrigger() {
    this.formS.updateCurrentStep(this.isActiveStep ? null : this.data().step);
    if (this.isActiveStep && this.showInputElem) {
      this.inputRef?.focus();
    }
  }

  public updateDropdownValue(event: Event) {
    this.formS.updateDropdownFilter((event.target as HTMLInputElement).value);
  }

  public handleInputClick(event:MouseEvent) {
    event.stopPropagation();
    if (!this.isActiveStep) {
      this.updateCurrentTrigger();
    }
  }
}
